import { WindowRef } from '../classes/window-ref.class';
import { windowFactory } from '../factories/window.factory';
import { WINDOW } from '../tokens/window.token';
import { FactoryProvider, PLATFORM_ID } from '@angular/core';

export const WINDOW_PROVIDER: FactoryProvider = {
  deps: [WindowRef, PLATFORM_ID],
  provide: WINDOW,
  useFactory: windowFactory,
};
